import axios from './axiosConfig';
import NotificationService from './NotificationService';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://api.local.dev:8080'}/api/shop`;

class MessagingService {
  static async list(archived = false) {
    const response = await axios.get(`${API_URL}/conversations`, {
      params: archived ? { archived: 1 } : {},
    });
    return response.data.data || [];
  }

  static async unreadCount() {
    try {
      const response = await axios.get(`${API_URL}/conversations/unread`);
      return response.data.data?.unread ?? 0;
    } catch (error) {
      return 0;
    }
  }

  static async get(id) {
    const response = await axios.get(`${API_URL}/conversations/${id}`);
    return response.data.data;
  }

  static async contactSupport(body) {
    const response = await axios.post(`${API_URL}/conversations/support`, { body });
    NotificationService.success('Message envoyé au support');
    return response.data.data;
  }

  static async send(id, body) {
    const response = await axios.post(`${API_URL}/conversations/${id}`, { body });
    NotificationService.success('Message envoyé');
    return response.data;
  }

  static async archive(id) {
    const response = await axios.post(`${API_URL}/conversations/${id}/archive`, { archived: true });
    return response.data;
  }

  static async report(id, messageId, reason) {
    const response = await axios.post(`${API_URL}/conversations/${id}/report`, { messageId, reason });
    NotificationService.success('Signalement enregistré');
    return response.data;
  }
}

export default MessagingService;
